import React, {FC, useEffect} from "react";
import './shop-item.less'
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import {getCouponsByShopId, getShopById} from "../../../bll/app-reducer";
import {useSelector} from "../../../hooks/redux-hooks";
import {Product} from "./Product";
import {Rate} from "antd";
import {NavLink} from "react-router-dom";
import {appSettings} from "../../../settings/AppSettings";

export const ShopItem: FC = () => {
    const params = useParams<{ id: string }>()
    const dispatch = useDispatch()

    const currentShop = useSelector(state => state.app.currentShop)
    const coupons = useSelector(state => state.app.coupons)

    useEffect(() => {
        dispatch(getShopById(+params.id))
        dispatch(getCouponsByShopId(+params.id))
        return () => {

        }
    }, [params.id])
    return <div>
        {currentShop && <div className="muztorg">
            <div className="main-caption-of-shop">
                <div className="strips-menu">
                    <div className='block-name'>
                        ПРОДАЖА МУЗЫКАЛЬНОГО ОБОРУДОВАНИЯ
                    </div>
                    <div className='block-name-link'>
                        <a href=''>{currentShop.title}</a>
                    </div>
                    <div className="container">
                        <div className="shop-item">
                            <div className="item">
                                <div className="icon">
                                    <img src={currentShop.image}/>
                                    {/*<img src={logo}/>*/}
                                </div>
                                <div className="description">
                                    <div className="name-shop">
                                        {currentShop.title}
                                        <div className="reviews">
                                            <div>ПОКУПОК: {currentShop.salesCount}</div>
                                            <Rate disabled allowHalf
                                                  defaultValue={currentShop.ratingSum / currentShop.salesCount}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a
                                href={`${appSettings.api.ADMIN_PANEL_BASE_URL}/shop/customer?shopId=${params.id}`}
                                target={'_blank'}
                                rel="noreferrer"
                            >
                                <button>ПОЛУЧИТЬ КУПОН</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="info">
                ОБЩАЯ ИНФОРМАЦИЯ
            </div>
            <div className="full-description">

                <div className="container">
                    <div className="row">

                        <div className="col-xl-4">
                            <div className='card-title title'> АДРЕС</div>
                            <span className="text-description">
                       {currentShop.contacts.address}
                             </span>
                        </div>
                        <div className="col-xl-4">
                            <div className='card-title title'> КОНТАКТЫ</div>
                            <div className="text-description">
                                {currentShop.contacts.email}
                                {currentShop.contacts.phone}
                                {currentShop.contacts.website}
                            </div>
                        </div>

                        <div className="col-xl-4">
                            <div className='card-title title'> ДОСТАВКА</div>
                            <div className="text-description">
                                {currentShop.allWorldDelivery ? <span>Доставка по всему миру</span> :
                                    <span>{currentShop.country} / {currentShop.city}</span>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {coupons.map(coupon => <Product coupon={coupon}/>)}
        </div>}
    </div>
}